'use strict';
import $ from 'jquery';
import slick from 'slick-carousel';

export default class Slider {
  constructor(el) {
    this.el = el;
    $(this.el).on('init', function(){
      $('body').addClass('initialized-slider');
    });
    $(this.el).slick({
      arrows: true,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      slidesToShow: el.dataset.columns || 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
}
